module.exports = __webpack_public_path__ + "img/present-banner.8614ee3d.png";